import React, {Component} from "react";
import classes from './BuySmartwatch.css'
import {connect} from "react-redux";
import * as actions from "../../store/actions";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from '../../components/UI/Button/Button'
import Modal from '../../components/UI/Modal/Modal';
import Box from "@mui/material/Box";
import styled from 'styled-components'
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import instance from "../../axios-spc";
import TableContainer from "@material-ui/core/TableContainer";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TablePagination from "@material-ui/core/TablePagination";
import Spinner from "../../components/UI/Spinner/Spinner";
import QRCode from 'qrcode.react';
import MenuItem from '@material-ui/core/MenuItem';
import Snackbar from "../../components/UI/Snackbar/Snackbar";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Error from '@material-ui/icons/Error';
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card/Card";
import Divider from '@mui/material/Divider';
import {MaterialReactTable} from "material-react-table";
import Autocomplete from "@mui/material/Autocomplete/Autocomplete";
import ednpointWeb from "../../endpoint";
import Link from "@material-ui/core/Link";


class BuySmartwatch extends Component{

    state = {
        brands: [],
        modelli: [],
        memoria: [],
        priceData: [],
        priceSvalutazione: [],
        idBrandSelezionato: null,
        idModelSelezionato: null,
        idMemoriaSelezionato: null,
        piceaData: null,
        piceaSupervalutazione: null,
        couponTotalPrice: 0,
        modalitaPagamento: {options: [

            ], value: 0},
        tipologiaDocumento: {options: [{key: 0, value: 0, displayValue: "Seleziona documento identificazione", disabled: true}, {key: 1, value: 1, displayValue: "Carta Identità", disabled: false}, {key: 2, value: 2, displayValue: "Passaporto", disabled: false}, {key: 3, value: 3, displayValue: "Patente", disabled: false}], value: 0},
        tipologiaSupervalutazione: {options: [{key: 0, value: 0, displayValue: "È presente un telefono acquistato con supervalutazione?", disabled: true}, {key: 1, value: 1, displayValue: "Si, è presente una supervalutazione", disabled: false}, {key: 2, value: 2, displayValue: "No, nessuna supervalutazione", disabled: false}], value: 0},
        nazione: {options: []},
        ricercaAnagrafica: {value: '', validation: {minLength: 3}, valid: false, touched: false, validationError: 'Inserire almeno 3 caratteri'},
        numeroDocumento: {value: '', validation: {required: true}, valid: false, touched: false,},
        isRicercaAnagrafica: false,
        isCreazioneAnagrafica: false,
        isModificaAnagrafica: false,
        nuovaAnagrafica: {
            cognome: {elementType: 'input', elementConfig: {type: 'input', placeholder: 'Cognome',}, value: '', validation: {required: true}, valid: false, touched: false},
            nome: {elementType: 'input', elementConfig: {type: 'input',placeholder: 'Nome',}, value: '', validation: {required: true}, valid: false, touched: false},
            codice_fiscale: {elementType: 'input', elementConfig: {type: 'input', placeholder: 'Codice Fiscale',}, value: '', validation: {required: true}, validationError: '', valid: false, touched: false},
            email: {elementType: 'input', elementConfig: {type: 'input',placeholder: 'Mail',}, value: '', validation: {required: true}, valid: false, touched: false},
            telefono_cellulare: {elementType: 'input', elementConfig: {type: 'input', placeholder: 'Cellulare',}, value: '', validation: {required: true}, valid: false, touched: false},
            citta: {elementType: 'input', elementConfig: {type: 'input',placeholder: 'Citta',}, value: '', validation: {required: true}, valid: false, touched: false},
            indirizzo: {elementType: 'input', elementConfig: {type: 'input', placeholder: 'Indirizzo',}, value: '', validation: {required: true}, valid: false, touched: false},
            numero_civico: {elementType: 'input', elementConfig: {type: 'input', placeholder: 'Civico',}, value: '', validation: {required: true}, valid: false, touched: false},
            cap: {elementType: 'input', elementConfig: {type: 'input', placeholder: 'Cap',}, value: '', validation: {required: true}, valid: false, touched: false},
            provincia: {elementType: 'input', elementConfig: {type: 'input', placeholder: 'Provincia',}, value: '', validation: {maxLength: 2}, validationError: 'Massimo 2 caratteri', valid: false, touched: false}
        },
        formAnagraficaIsValid: false,
        page: 0,
        rowsPerPage: 3,
        listaAnagrafiche: [],
        loading: false,
        clienteSelezionato: null,
        clienteDaModificare: null,
        documentoInserito: false,
        nazioneEsteraChecked: false,
        numTimes: 0,
        idRicevuta: 0,
        isStampaDocumento: false,
        isDocumentoFirmato: false,
        loadingPicea: false,
        isProcessoPending: false,
        snToDelete: null,
        isSupervalutazione: false,
        supervalutazioneInserita: false,
        valoreSupervalutazione: null,
        isAffiliatoAttivoSupervalutazione: false,
        isAffiliatoListinoRidotto: false,
        imeiSupervalutazione: {value: '', validation: {required: true}, valid: false, touched: false},
        skuSupervalutazione: {value: '', validation: {required: true}, valid: false, touched: false},
        eanSupervalutazione: {value: '', validation: {required: true}, valid: false, touched: false},
        datiSupervalutazione: {imei: 0, serial: 0, ean: 0, sku_campagna: null},
        highestPrice: 0,
        highestPriceLimit: 0,
        isNecessariaRicevuta: false,
        isRicevutaAcquisita: false,
        loginCode: null,
        deviceInfo: null,
        deviceInfoError: null,
        deviceName: null,
        deviceMaxPrice: 0,
        campagne: [],
        modelNameCampagna: null,
        deviceRealPrice: 0,
        isAccountEliminato: false,
        confirmCopy: false,
        anchorEl: null,
        isInserimentoManuale: false,
        isInserimentoManualeFatto: false,
        marcaManuale: null,
        modelloManuale: null,
        memoriaManuale: null,
        imeiManuale: null,
        valorePermutaContanti: 90,
        isConsoleSelezionata: false,
        domande: [],
        lettoreCd: true,
        risposteInserite: false,
        serialeConsole: {value: '', validation: {required: true}, valid: false, touched: false},

    };

    componentDidMount() {
        this.props.onAuthCheckState();
        this.getBrands();
        this.getDomande();
        let newOptions = [
            {key: 0, value: 0, displayValue: "Seleziona", disabled: true},
            {key: 1, value: 1, displayValue: "Buono", disabled: false},
            {key: 2, value: 2, displayValue: "Contanti", disabled: false},
            // {key: 3, value: 3, displayValue: "Stripe", disabled: false}
        ];
        var postData = {
            id_affiliato: localStorage.getItem("idAffiliato"),
        };
        instance.post('/getPaymentTypes', postData).then(resp => {
            console.log(resp);
            if (resp.data.length > 0 && resp.data[0].spc_id_customer_payment_type === 2) {
                newOptions = [
                    {key: 0, value: 0, displayValue: "Seleziona", disabled: true},
                    {key: 1, value: 1, displayValue: "Buono", disabled: false},
                ]
            }
            let updateOption = {...this.state.modalitaPagamento};
            updateOption.options = newOptions;
            this.setState({modalitaPagamento: updateOption});
        });

        let idAffiliato = localStorage.getItem("idAffiliato");
        let affiliatiAttiviList = window.config.idAffiliatiAttiviSupervalutazione;
        let affiliatiAttiviArray = [];
        if (affiliatiAttiviList.length > 0) {
            affiliatiAttiviArray = affiliatiAttiviList.split(",");
        }
        let isAffiliatoAttivo = false;
        for (let i = 0; i < affiliatiAttiviArray.length && !isAffiliatoAttivo; ++i) {
            isAffiliatoAttivo = affiliatiAttiviArray[i] === idAffiliato
        }

        let affiliatiListinoRidottoList = window.config.idAffiliatiListinoRidotto;
        let affiliatiListinoRidottoArray = [];
        if (affiliatiListinoRidottoList.length > 0) {
            affiliatiListinoRidottoArray = affiliatiListinoRidottoList.split(",");
        }
        let isAffiliatoListinoRidotto = false;
        for (let i = 0; i < affiliatiListinoRidottoArray.length && !isAffiliatoListinoRidotto; ++i) {
            isAffiliatoListinoRidotto = affiliatiListinoRidottoArray[i] === idAffiliato
        }

        let highestPriceLimit = window.config.limiteValorePerRicevuta;

        let decurtazioneContantiAffiliatoList = "207:60";
        // let decurtazioneContantiAffiliatoList = window.config.decurtazioneContantiAffiliati;
        let decurtazioneContantiAffiliatoArray = [];
        if (decurtazioneContantiAffiliatoList.length > 0) {
            decurtazioneContantiAffiliatoArray = decurtazioneContantiAffiliatoList.split(",");
        }
        let valorePermutaContanti = 90;
        let trovato = false;
        for (let i = 0; i < decurtazioneContantiAffiliatoArray.length && !trovato; ++i) {
            let idAffiliatoInLista = decurtazioneContantiAffiliatoArray[i].split(":")[0];
            let decurtazione = decurtazioneContantiAffiliatoArray[i].split(":")[1];
            if (idAffiliatoInLista === idAffiliato) {
                valorePermutaContanti = decurtazione;
                trovato = true;
            }
        }
        console.log(valorePermutaContanti);

        this.setState({isAffiliatoAttivoSupervalutazione: isAffiliatoAttivo, isAffiliatoListinoRidotto: isAffiliatoListinoRidotto, highestPriceLimit: highestPriceLimit, valorePermutaContanti: valorePermutaContanti});
    }

    getBrands = () => {
        var postData = {
            id_negozio: localStorage.getItem("idNegozio"),
        };
        instance.post('/getPriceCheckBrands', postData).then(resp => {
            console.log(resp);
            let result = resp.data.filter(function (el) {
                return (el.id_brand === 3 || el.id_brand === 6 || el.id_brand === 7 || el.id_brand === 9 ||
                    el.id_brand === 16 || el.id_brand === 17 || el.id_brand === 19 || el.id_brand === 20 ||
                    el.id_brand === 25 || el.id_brand === 29 || el.id_brand === 30 || el.id_brand === 31 ||
                    el.id_brand === 32 || el.id_brand === 33 || el.id_brand === 34 || el.id_brand === 35 || el.id_brand === 36)
            }).map( el => ({key: el.id_brand, value: el.id_brand, label: el.brand_name}) );
            this.setState({brands: result})
        });
    };

    getDomande = () => {
        var postData = {
            id_device_type: 3,
        };
        instance.post('/getDomandeValutazione', postData).then(resp => {
            const grouped = {};

            resp.data.forEach(item => {
                if (!grouped[item.id_domanda]) {
                    grouped[item.id_domanda] = {
                        id_domanda: item.id_domanda,
                        domanda: item.domanda,
                        risposte: [],
                        rispostaSelezionata: null,
                        bgColor: null
                    };
                }

                grouped[item.id_domanda].risposte.push({
                    id_risposta: item.id_risposta,
                    risposta: item.risposta,
                    svalutazione: item.svalutazione,
                    id_color: item.id_color
                });
            });
            this.setState({domande: Object.values(grouped)});
            console.log(this.state.domande);
        });
    };

    getModels = (idBrand) => {
        var postData = {
            id_negozio: localStorage.getItem("idNegozio"),
            id_brand: idBrand,
            id_device_type: 3
        };
        instance.post('/getPriceCheckModels', postData).then(resp => {
            let result = resp.data.map( el => ({key: el.id_model_name, value: el.id_model_name, label: el.model_name + (el.model_code != null ? " - [" + el.model_code + "]" : ""), cd: el.lettore_cd}) )
            this.setState({modelli: result})
        });
    };

    getMemory = (idModel) => {
        var postData = {
            id_negozio: localStorage.getItem("idNegozio"),
            id_model_name: idModel
        };
        instance.post('/getPriceModelsMemory', postData).then(resp => {
            let result = resp.data.map( el => ({key: el.id_memory, value: el.id_memory, label: el.memory}) )
            this.setState({memoria: result})
        });
    };


    onBrandsChange = (event, values) => {
        if (values) this.setState({idBrandSelezionato: values.value, supervalutazioneScelta: null, gradoEsteticoScelto: null, priceData: null, marcaManuale: values.label}, this.getModels( values.key)); else this.setState({modelli: [], modelloManuale: null, deviceInfo: null, isConsoleSelezionata: null});
    };
    onModelsChange = (event, values) => {
        if (values) this.setState({idModelSelezionato: values.value, supervalutazioneScelta: null, gradoEsteticoScelto: null, priceData: null, modelloManuale: values.label, lettoreCd: values.cd, memoriaManuale: 'Unique'})
    };
    onMemoryChange = (event, values) => {
        if (values) this.setState({idMemoriaSelezionato: values.value, supervalutazioneScelta: null, gradoEsteticoScelto: null, priceData: null, memoriaManuale: values.label})
    };

    openModalRicercaCliente = (value) => {
        console.log(value);
        this.setState({loading: true});
        let clienti = [];
        var postData = {
            id_negozio: localStorage.getItem("idNegozio"),
            cognome: value,
            codice_fiscale: null,
            ragione_sociale: null,
            partita_iva: null
        };

        instance.post('/getClientiByCognome', postData)
            .then(response => {
                for (let key in response.data) {
                    clienti.push({...response.data[key], id: key})
                }
                this.setState({listaAnagrafiche: clienti, loading: false});
                console.log(clienti.length)
            })
            .catch(error => {
                console.log(error);
                this.setState({loading: false});
            });
        this.setState({isRicercaAnagrafica: true})
    };

    openModalCreazioneAnagrafica = () => {
        this.getListaNazioni();
        this.setState({isCreazioneAnagrafica: true})
    };

    openModalCondizioniEstetiche = () => {
        this.setState({isValutazioneEstetica: true, isValutazioneEsteticaDefinita: false})
    };

    valutazioneEsteticaCloseHandler = () => {

        this.setState({isValutazioneEstetica: false})
    };

    ricercaCancelHandler = () => {
        this.setState({isRicercaAnagrafica: false, isCreazioneAnagrafica: false, isModificaAnagrafica: false, clienteDaModificare: null})
    };

    selezionaAnagrafica = (cliente) => {
        this.setState({isRicercaAnagrafica: false, clienteSelezionato: cliente})
    };

    modificaAnagrafica = (cliente) => {
        this.setState({isRicercaAnagrafica: false, isModificaAnagrafica: true, clienteDaModificare: cliente})
    };

    annullaModalitaPagamento = () => {
        let newPrice = this.state.deviceRealPrice;
        if (this.state.modalitaPagamento.value === 2) {
            let oldPrice = this.state.deviceRealPrice;
            newPrice = (oldPrice / (this.state.valorePermutaContanti / 100)).toFixed(2);
        }
        const updatedForm = {
            ...this.state.modalitaPagamento
        };
        updatedForm.value = 0;
        const updatedFormDoc = {
            ...this.state.numeroDocumento
        };
        updatedFormDoc.value = "";
        const updatedFormCliente = {
            ...this.state.ricercaAnagrafica
        };
        updatedFormCliente.value = "";
        const updatedFormTipoDoc = {
            ...this.state.tipologiaDocumento
        };
        updatedFormTipoDoc.value = "";
        this.setState({deviceRealPrice: newPrice, modalitaPagamento: updatedForm, clienteSelezionato: null, documentoInserito: false, numeroDocumento: updatedFormDoc, ricercaAnagrafica: updatedFormCliente, tipologiaDocumento: updatedFormTipoDoc});
    };

    annullaCliente = () => {
        const updatedFormDoc = {
            ...this.state.numeroDocumento
        };
        updatedFormDoc.value = "";
        const updatedFormCliente = {
            ...this.state.ricercaAnagrafica
        };
        updatedFormCliente.value = "";
        const updatedFormTipoDoc = {
            ...this.state.tipologiaDocumento
        };
        updatedFormTipoDoc.value = "";
        this.setState({clienteSelezionato: null, documentoInserito: false, numeroDocumento: updatedFormDoc, ricercaAnagrafica: updatedFormCliente, tipologiaDocumento: updatedFormTipoDoc});
    };

    annullaDoc = () => {
        const updatedFormDoc = {
            ...this.state.numeroDocumento
        };
        updatedFormDoc.value = "";
        const updatedFormTipoDoc = {
            ...this.state.tipologiaDocumento
        };
        updatedFormTipoDoc.value = "";
        this.setState({documentoInserito: false, numeroDocumento: updatedFormDoc, tipologiaDocumento: updatedFormTipoDoc});
    };

    annullaTelefono = () => {
        const updatedFormDoc = {
            ...this.state.imeiSupervalutazione
        };
        updatedFormDoc.value = "";
        const updatedFormTipoDoc = {
            ...this.state.tipologiaSupervalutazione
        };
        updatedFormTipoDoc.value = 0;
        const updatedFormMarcaSupervalutazione = {
            ...this.state.marcaSupervalutazione
        };
        updatedFormMarcaSupervalutazione.value = 0;
        const updatedSkuDoc = {
            ...this.state.skuSupervalutazione
        };
        updatedSkuDoc.value = "";
        const updatedEanDoc = {
            ...this.state.eanSupervalutazione
        };
        updatedEanDoc.value = "";
        let updatedCoupon = {
            serial_number: this.state.piceaData.serial_number,
            coupon_value: +this.state.piceaData.valore_acquisto
        };
        instance.post('/updateCoupon', updatedCoupon).then(function (resp) {
            console.log(resp)
        });

        this.setState({valoreSupervalutazione: null, supervalutazioneInserita: false, isSupervalutazione: false, imeiSupervalutazione: updatedFormDoc, tipologiaSupervalutazione: updatedFormTipoDoc, piceaImeiInvalid: false, marcaSupervalutazione: updatedFormMarcaSupervalutazione, skuSupervalutazione: updatedSkuDoc, eanSupervalutazione: updatedEanDoc, modelNameCampagna: null});
    };

    annullaNumeroDoc = () => {
        const updatedFormDoc = {
            ...this.state.numeroDocumento
        };
        updatedFormDoc.value = "";
        this.setState({documentoInserito: false, numeroDocumento: updatedFormDoc});
    };

    annullaImei = () => {
        const updatedFormDoc = {
            ...this.state.imeiSupervalutazione
        };
        updatedFormDoc.value = "";
        const updatedSkuDoc = {
            ...this.state.skuSupervalutazione
        };
        updatedSkuDoc.value = "";
        const updatedFormTipoDoc = {
            ...this.state.tipologiaSupervalutazione
        };
        updatedFormTipoDoc.value = 0;
        const updatedEanDoc = {
            ...this.state.eanSupervalutazione
        };
        updatedEanDoc.value = "";
        let updatePrice = this.state.deviceRealPrice - this.state.valoreSupervalutazione;
        // if (this.state.marcaSupervalutazione.value === 'Samsung') updatePrice = this.state.deviceRealPrice
        if (this.state.piceaData) {
            let updatedCoupon = {
                serial_number: this.state.piceaData.serial_number,
                coupon_value: updatePrice,
                num_times: this.state.numTimes
            };
            instance.post('/updateCoupon', updatedCoupon).then(function (resp) {
                if (resp.data[0].ret_code === 0) {
                    console.log(resp.data[0])
                }
            });
        }
        this.setState({deviceRealPrice: updatePrice, supervalutazioneInserita: false, imeiSupervalutazione: updatedFormDoc, valoreSupervalutazione: null, skuSupervalutazione: updatedSkuDoc, tipologiaSupervalutazione: updatedFormTipoDoc, eanSupervalutazione: updatedEanDoc, modelNameCampagna: null});
    };

    handleChange = (event) => {
        console.log("onChange");
        const value = event.target.value;
        const oldState = {...this.state};
        const oldForm = {...oldState.nuovaAnagrafica};
        oldForm[event.target.name].value = value;
        this.setState({nuovaAnagrafica: oldForm})
    };

    handleChangeModifica = (event) => {
        console.log("onChange");
        const value = event.target.value;
        const oldAnagrafica = {...this.state.clienteDaModificare};
        oldAnagrafica[event.target.name] = value;
        this.setState({clienteDaModificare: oldAnagrafica})
    };

    handleChangeAnagrafica = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.nuovaAnagrafica
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        if (inputIdentifier === 'codice_fiscale') {
            updatedFormElement.valid = updatedFormElement.value.match(/^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/);
            !updatedFormElement.valid ? updatedFormElement.validationError = 'Codice Fiscale non valido' : updatedFormElement.validationError = '';
            if (this.state.nazioneEsteraChecked) {
                updatedFormElement.valid = true;
                updatedFormElement.validationError = '';
            }
        } else if (inputIdentifier === 'email') {
            updatedFormElement.valid = updatedFormElement.value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            !updatedFormElement.valid ? updatedFormElement.validationError = 'Indirizzo mail non valido' : updatedFormElement.validationError = '';
        } else {
            updatedFormElement.valid = this.checkValidity(updatedFormElement.value, updatedFormElement.validation);
            !updatedFormElement.valid ? updatedFormElement.validationError = 'Campo obbligatorio' : updatedFormElement.validationError = '';
            if (inputIdentifier === 'provincia') updatedFormElement.validationError = 'Massimo 2 caratteri'
        }
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputId in updatedForm) {
            formIsValid = updatedForm[inputId].valid && formIsValid
        }
        if (this.state.nazioneEsteraChecked) {
            formIsValid = true;
        }
        this.setState({nuovaAnagrafica: updatedForm, formAnagraficaIsValid: formIsValid});
    };

    setValutazioneEstetica = () => {
        let deprezzamento = 1;
        switch (this.state.gradoValutazioneEstetica) {
            case "A":
                deprezzamento = 1;
                break;
            case "A-":
                deprezzamento = 0.95;
                break;
            case "B+":
                deprezzamento = 0.9;
                break;
            case "B-":
                deprezzamento = 0.8;
                break;
            case "C+":
                deprezzamento = 0.5;
                break;
            case "C-":
                deprezzamento = 0.2;
                break;
        }
        if (this.state.deviceRealPrice > 2) {
            let oldPrice = this.state.deviceMaxPrice;
            this.setState({isValutazioneEstetica: false, isValutazioneEsteticaDefinita: true, deviceRealPrice: (oldPrice * deprezzamento).toFixed(2)})
        }
        this.setState({isValutazioneEstetica: false, isValutazioneEsteticaDefinita: true});
        console.log("GRADO " + this.state.gradoValutazioneEstetica);
    };

    confermaEliminazioneAccount = () => {
        this.setState({ isAccountEliminato: true});
    };

    creaAnagrafica = () => {
        var postData = {
            id_cliente: null,
            nome: this.state.nuovaAnagrafica.nome.value,
            cognome: this.state.nuovaAnagrafica.cognome.value,
            codice_fiscale: this.state.nuovaAnagrafica.codice_fiscale.value,
            ragione_sociale: null,
            partita_iva: null,
            codice_destinatario_b2b: null,
            pec_destinatario_b2b: null,
            is_associazione: null,
            indirizzo: this.state.nuovaAnagrafica.indirizzo.value,
            numero_civico: this.state.nuovaAnagrafica.numero_civico.value,
            citta: this.state.nuovaAnagrafica.citta.value,
            cap: this.state.nuovaAnagrafica.cap.value,
            email: this.state.nuovaAnagrafica.email.value,
            sigla_provincia: this.state.nuovaAnagrafica.provincia.value,
            telefono_cellulare: this.state.nuovaAnagrafica.telefono_cellulare.value,
            nazione: this.state.nuovaAnagrafica.nazione,
            id_negozio: localStorage.getItem("idNegozio"),
        };
        if (this.state.clienteDaModificare) {
            let sigla = this.state.clienteDaModificare.provincia;
            this.state.clienteDaModificare.sigla_provincia = sigla;
            this.state.clienteDaModificare.id_negozio = localStorage.getItem("idNegozio");
            postData = this.state.clienteDaModificare;
        }
        instance.post('/setCliente', postData)
            .then(response => {
                if (response.data[0].ret_code === 0) {
                    let nuovoCliente = {...postData};
                    nuovoCliente.id_cliente = response.data[0].id_cliente;
                    this.setState({clienteSelezionato: nuovoCliente, isCreazioneAnagrafica: false, isModificaAnagrafica: false})
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({loading: false});
            });
        this.setState({isCreazioneAnagrafica: false})
    };

    inputonChangeHandler = (event, id) => {
        switch (id) {
            case "modalitaPagamento": {
                const updatedForm = {
                    ...this.state.modalitaPagamento
                };
                updatedForm.value = event.target.value;

                if (event.target.value == 2) {
                    let oldPrice = this.state.deviceRealPrice;
                    let newPrice = Math.ceil(oldPrice * (this.state.valorePermutaContanti / 100)).toFixed(2);
                    this.setState({deviceRealPrice: newPrice});
                }

                this.setState({modalitaPagamento: updatedForm});
                break;
            }
            case "ricercaAnagrafica": {
                const updatedForm = {
                    ...this.state.ricercaAnagrafica
                };
                updatedForm.value = event.target.value;
                updatedForm.valid = this.checkValidity(updatedForm.value, updatedForm.validation);
                updatedForm.touched = true;
                this.setState({ricercaAnagrafica: updatedForm});
                break;
            }
            case "serialeConsole": {
                const updatedForm = {
                    ...this.state.serialeConsole
                };
                updatedForm.value = event.target.value;
                updatedForm.valid = this.checkValidity(updatedForm.value, updatedForm.validation);
                updatedForm.touched = true;
                this.setState({serialeConsole: updatedForm});
                break;
            }
            case "numeroDocumento": {
                const updatedForm = {
                    ...this.state.numeroDocumento
                };
                updatedForm.value = event.target.value;
                updatedForm.valid = this.checkValidity(updatedForm.value, updatedForm.validation);
                updatedForm.touched = true;
                this.setState({numeroDocumento: updatedForm});
                break;
            }
            case "tipologiaDocumento": {
                const updatedForm = {
                    ...this.state.tipologiaDocumento
                };
                updatedForm.value = event.target.value;
                this.setState({tipologiaDocumento: updatedForm});
                break;
            }
            case "tipologiaSupervalutazione": {
                const updatedForm = {
                    ...this.state.tipologiaSupervalutazione
                };
                updatedForm.value = event.target.value;
                this.setState({tipologiaSupervalutazione: updatedForm});
                break;
            }
            case "imeiSupervalutazione": {
                const updatedForm = {
                    ...this.state.imeiSupervalutazione
                };
                updatedForm.value = event.target.value;
                this.setState({imeiSupervalutazione: updatedForm});
                break;
            }
            case "skuSupervalutazione": {
                const updatedForm = {
                    ...this.state.skuSupervalutazione
                };
                updatedForm.value = event.target.value;
                this.setState({skuSupervalutazione: updatedForm});
                break;
            }
            case "eanSupervalutazione": {
                const updatedForm = {
                    ...this.state.eanSupervalutazione
                };
                updatedForm.value = event.target.value;
                this.setState({eanSupervalutazione: updatedForm});
                break;
            }
            case "marcaSupervalutazione": {
                const updatedForm = {
                    ...this.state.marcaSupervalutazione
                };
                updatedForm.value = event.target.value;
                this.setState({marcaSupervalutazione: updatedForm});
                break;
            }
            case "piceaLink": {
                this.setState({piceaLink: event.target.value});
                break;
            }
            case "valoreSupervalutazione": {
                this.setState({valoreSupervalutazione: event.target.value});
                break;
            }
            default: {
                const oldState = {
                    ...this.state
                };
                this.setState({state: oldState});
                break;
            }
        }

    };

    checkValidity(value, rules) {
        let isValid = true;
        if (rules) {
            if (rules.required) {
                isValid = value.trim() !== '' && isValid;
            }
            if (rules.minLength) {
                isValid = value.length >= rules.minLength && isValid
            }
            if (rules.maxLength) {
                isValid = value.length <= rules.maxLength && isValid
            }
        }
        return isValid
    }

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage});
    };
    handleChangeRowsPerPage = (event) => {
        this.setState({rowsPerPage: +event.target.value, page: 0})
    };
    handleChangeCheckBox = (event) => {
        this.setState({nazioneEsteraChecked: event.target.checked})
    };
    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return ;
        }
        const updatedFormMarcaSupervalutazione = {
            ...this.state.marcaSupervalutazione
        };
        updatedFormMarcaSupervalutazione.value = 0;
        this.setState({isStampaDocumento: false, piceaImeiInvalid: false, marcaSupervalutazione: updatedFormMarcaSupervalutazione, valoreSupervalutazione: null, confirmCopy: false})
    };

    selezionaSupervalutazione = (data) => {
        console.log(data);
        const updatedForm = {
            ...this.state.tipologiaSupervalutazione
        };
        updatedForm.value = 1;
        const updatedFormMarca = {
            ...this.state.marcaSupervalutazione
        };
        updatedFormMarca.value = data.brand_campagna;
        const updateFormDati = {
            ...this.state.datiSupervalutazione
        };
        updateFormDati.imei = data.imei;
        updateFormDati.serial = data.serial;
        updateFormDati.ean = data.ean;
        updateFormDati.sku_campagna = data.sku;
        this.setState({marcaSupervalutazione: updatedFormMarca, tipologiaSupervalutazione: updatedForm,valoreSupervalutazione: data.supervalutazione, modelNameCampagna: data.model_name_campagna, datiSupervalutazione: updateFormDati });
    };


    confermaSupervalutazione = () => {
        console.log("é stata inserito un imei per la supervalutazione " + this.state.imeiSupervalutazione);
        this.setState({supervalutazioneInserita: true});

        let supervalutazioneValore = +this.state.valoreSupervalutazione;
        let updatedCoupon = {
            serial_number: this.state.piceaData.serial_number,
            coupon_value: +this.state.deviceRealPrice + +supervalutazioneValore,
            num_times: this.state.numTimes
        };

        let numTimes = this.state.numTimes;
        let valoreAcquisto = this.state.deviceRealPrice;

        let samsungInfo = {
            imei: this.state.imeiSupervalutazione.value,
        };

        if (this.state.marcaSupervalutazione.value === 'Samsung' && this.state.datiSupervalutazione.imei === 1) {

            instance.post('/checkSamsungImei', samsungInfo).then(resp => {
                let data = resp.data;

                if (data.imei_used === false && data.status === 'IMEI_FOUND') {
                    this.setState({piceaImeiInvalid: false});
                    instance.post('/updateCoupon', updatedCoupon).then(function (resp) {
                        if (resp.data[0].ret_code === 0) {
                            let imeiSupervalutazione = {
                                serial_number: updatedCoupon.serial_number,
                                num_times: numTimes,
                                imei_acquistato: data.imei,
                                sku: data.sku,
                                ean: data.ean,
                                sku_campagna: this.state.datiSupervalutazione.sku_campagna
                            };
                            instance.post('/setImeiSupervalutazione', imeiSupervalutazione).then(function (r) {
                                console.log(r);
                                let samsungInfo = {
                                    imei: data.imei,
                                    marketing_name: 'SmartphoneCash',
                                    brand_name: "Eco Store",
                                    device_value: +valoreAcquisto,
                                    voucher_value: (+updatedCoupon.coupon_value),
                                    store_name: localStorage.getItem("ragione_sociale") != null ? localStorage.getItem("ragione_sociale") : 'Eco Store',
                                    store_city: localStorage.getItem("nomeNegozio").substring(0, localStorage.getItem("nomeNegozio").indexOf("-")),
                                    store_province: "PV"
                                };
                                console.log(samsungInfo);
                                instance.post('/setSamsungImei', samsungInfo).then(resp => {
                                    console.log(resp.data);
                                    this.setState({deviceRealPrice: updatedCoupon.coupon_value})
                                }).catch(err => {
                                    console.log(err)
                                })
                            })
                        }
                    });
                } else {
                    this.setState({piceaImeiInvalid: true});
                }
            })
        } else {
            console.log("Scelto Altro");
            let that = this;
            this.setState({piceaImeiInvalid: false});
            let otherImei = this.state.imeiSupervalutazione.value;
            let sku = this.state.skuSupervalutazione.value === '' ? (this.state.marcaSupervalutazione.value + '-SKU') : this.state.skuSupervalutazione.value;
            let ean = this.state.eanSupervalutazione.value === '' ? (this.state.marcaSupervalutazione.value + '-EAN') : this.state.eanSupervalutazione.value;
            let sku_campagna = this.state.datiSupervalutazione.sku_campagna;
            instance.post('/updateCoupon', updatedCoupon).then(function (resp) {
                if (resp.data[0].ret_code === 0) {
                    let imeiSupervalutazione = {
                        serial_number: updatedCoupon.serial_number,
                        num_times: numTimes,
                        imei_acquistato: otherImei,
                        sku: sku,
                        ean: ean,
                        sku_campagna: sku_campagna
                    };
                    instance.post('/setImeiSupervalutazione', imeiSupervalutazione).then(function (r) {
                        console.log(r);
                        that.setState({deviceRealPrice: updatedCoupon.coupon_value})
                    }).catch(err => {
                        console.log(err)
                    })
                }
            });
        };
    };

    confermaDocumento = () => {

        if (this.state.modalitaPagamento.value === 1) {
            let couponData = {
                serial_number: this.state.piceaData.serial_number,
                num_times: this.state.numTimes,
            };
            instance.post('/setCoupon', couponData).then(resp => {
                let postData = {
                    serial_number: this.state.piceaData.serial_number,
                    num_times: this.state.numTimes,
                    id_negozio: localStorage.getItem("idNegozio"),
                    id_operatore: localStorage.getItem("userId"),
                    id_cliente: this.state.clienteSelezionato.id_cliente,
                    id_tipo_documento: this.state.tipologiaDocumento.value,
                    numero_documento: this.state.numeroDocumento.value,
                    is_coupon: 1,
                    coupon_serial_number: resp.data[0].coupon_serial_number,
                };
                instance.post('/setRicevuta', postData)
                    .then(response => {
                        this.setState({documentoInserito: true})
                    })
                    .catch(error => {
                        console.log(error);
                    });
            });
        } else {
            let postData = {
                serial_number: this.state.piceaData.serial_number,
                num_times: this.state.numTimes,
                id_negozio: localStorage.getItem("idNegozio"),
                id_operatore: localStorage.getItem("userId"),
                id_cliente: this.state.clienteSelezionato.id_cliente,
                id_tipo_documento: this.state.tipologiaDocumento.value,
                numero_documento: this.state.numeroDocumento.value,
                is_coupon: 0,
                coupon_serial_number: null,
            };
            instance.post('/setRicevuta', postData)
            // axios.post('http://localhost:8989/api/setRicevuta', postData)
                .then(response => {
                    this.setState({documentoInserito: true})
                })
                .catch(error => {
                    console.log(error);
                });
        }

    };

    confermaDocumentoPhoneCheck = () => {

        console.log(this.state.deviceInfo.make);
        const deviceData = {
            serial_number: this.state.deviceInfo.loginCode,
            brand_name: this.state.deviceInfo.make,
            model_name: this.state.deviceInfo.modelName != '' ? this.state.deviceInfo.modelName.replace(/\[.+?\]/, "").replaceAll(" -", "") : this.state.deviceInfo.modelNo,
            model_code: this.state.deviceInfo.modelNo,
            region_code: null,
            num_times: this.state.numTimes == 0 ? 1 : this.state.numTimes,
            imei: this.state.deviceInfo.imei,
            imei2: this.state.deviceInfo.imei2,
            meid: null,
            color: (this.state.deviceInfo.color == null || this.state.deviceInfo.color == '' ) ? 'Various' : this.state.deviceInfo.color,
            memory_gb: this.state.deviceInfo.memory.replaceAll(" ", '').replaceAll(".00", '').replaceAll('GB', '').replaceAll('TB', ''),
            report_id: this.state.deviceInfo.id,
            evaluation_id: this.state.deviceInfo.id,
            valore_iniziale: 0,
            valore_acquisto: this.state.deviceRealPrice,
            id_operatore: localStorage.getItem("userId"),
            id_negozio: localStorage.getItem("idNegozio"),
            grado_estetico: this.state.gradoValutazioneEstetica
        };

        instance.post('/setNewDevice', deviceData).then(resp => {
            let numTimes = 1;
            let highestPrice = this.state.deviceRealPrice;
            let that = this;
            if (resp.data[0].ret_code === 0) {
                numTimes = resp.data[0].num_times;
                this.state.domande.forEach(function (domanda) {
                    let postData = {
                        serial_number: deviceData.serial_number,
                        num_times: numTimes,
                        id_domanda: domanda.id_domanda,
                        id_risposta: domanda.rispostaSelezionata
                    };
                    instance.post('/setRisposteConsole', postData).then(resp => {
                        console.log(resp)
                    })
                });
                this.setState({
                    piceaData: deviceData,
                    numTimes: resp.data[0].num_times,
                    loadingPicea: false,
                    isProcessoPending: false,
                    isNecessariaRicevuta: +highestPrice > +this.state.highestPriceLimit
                });

                if (this.state.modalitaPagamento.value === 1) {
                    let couponData = {
                        serial_number: this.state.deviceInfo.loginCode,
                        num_times: numTimes,
                    };
                    instance.post('/setCoupon', couponData).then(resp => {
                        let postData = {
                            serial_number: this.state.deviceInfo.loginCode,
                            num_times: numTimes,
                            id_negozio: localStorage.getItem("idNegozio"),
                            id_operatore: localStorage.getItem("userId"),
                            id_cliente: this.state.clienteSelezionato.id_cliente,
                            id_tipo_documento: this.state.tipologiaDocumento.value,
                            numero_documento: this.state.numeroDocumento.value,
                            is_coupon: 1,
                            coupon_serial_number: resp.data[0].coupon_serial_number,
                        };
                        instance.post('/setRicevuta', postData)
                            .then(response => {
                                this.setState({documentoInserito: true})
                            })
                            .catch(error => {
                                console.log(error);
                            });
                    });
                } else {
                    let postData = {
                        serial_number: this.state.deviceInfo.loginCode,
                        num_times: resp.data[0].num_times,
                        id_negozio: localStorage.getItem("idNegozio"),
                        id_operatore: localStorage.getItem("userId"),
                        id_cliente: this.state.clienteSelezionato.id_cliente,
                        id_tipo_documento: this.state.tipologiaDocumento.value,
                        numero_documento: this.state.numeroDocumento.value,
                        is_coupon: 0,
                        coupon_serial_number: null,
                    };
                    instance.post('/setRicevuta', postData)
                        .then(response => {
                            this.setState({documentoInserito: true})
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }


            } else if (resp.data[0].ret_code === 3) {
                this.setState({
                    piceaData: resp.data[0].ret_message.replaceAll("_", " "),
                    loadingPicea: false,
                    isProcessoPending: true,
                    isNecessariaRicevuta: false,
                    snToDelete: deviceData.serial_number
                })
            } else {
                this.setState({
                    piceaData: resp.data[0].ret_message.replaceAll("_", " "),
                    loadingPicea: false,
                    isProcessoPending: false
                })
            }
        });

    }

    getListaNazioni = () => {
        let postData = {
            id_paese: null
        };
        instance.post('/getNazioni', postData)
        // axios.post('http://localhost:8989/api/getNazioni', postData)
            .then(response => {
                const updatedForm = {
                    ...this.state.nazione
                };
                let newOption = response.data;
                updatedForm.options = newOption;
                this.setState({nazione: updatedForm})
            })
            .catch(error => {
                console.log(error);
                this.setState({loading: false});
            });
        this.setState({isCreazioneAnagrafica: false})
    };

    delOldDevice = () => {
        let postData = {
            serial_number: this.state.snToDelete,
        };
        instance.post('/delPendingDevice', postData)
        // axios.post('http://localhost:8989/api/delPendingDevice', postData)
            .then(response => {
                if (response.data[0].ret_code === 0) {
                    this.setState({snToDelete: null, isProcessoPending: false});
                    this.submitHandler();
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({snToDelete: null, isProcessoPending: false});
            });
    };

    checkRicevutaFirmata = () => {
        this.setState({isStampaDocumento: true});
        let postData = {
            serial_number: this.state.piceaData.serial_number,
            num_times: this.state.numTimes,
            id_negozio: localStorage.getItem("idNegozio"),
            id_operatore: localStorage.getItem("userId")
        };
        instance.post('/getRicevuta', postData)
            .then(response => {
                if (response.data[0].firma_privacy !== null) {
                    this.setState({isDocumentoFirmato: true});
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({loading: false});
            });
    };

    handleChangeSupervalutazione = (e) => {
        let supervalutazione = e.target.value === "true";
        this.setState({isSupervalutazione: supervalutazione});
    };

    ricevutaPresente = () => {
        this.setState({isRicevutaAcquisita: true, isNecessariaRicevuta: false});
    };

    annullaInserimentoDevice = () => {
        let postData = {
            serial_number: this.state.piceaData.serial_number,
            num_times: this.state.numTimes,
            id_negozio: localStorage.getItem("idNegozio"),
            id_operatore: localStorage.getItem("userId")
        };
        instance.post('/deleteDevicePending', postData)
            .then(response => {
                this.setState({loading: false});
            })
            .catch(error => {
                console.log(error);
                this.setState({loading: false});
            });
        const updatedForm = {
            ...this.state.modalitaPagamento
        };
        updatedForm.value = 0;
        const updatedFormDoc = {
            ...this.state.numeroDocumento
        };
        updatedFormDoc.value = "";
        const updatedFormCliente = {
            ...this.state.ricercaAnagrafica
        };
        updatedFormCliente.value = "";
        const updatedFormTipoDoc = {
            ...this.state.tipologiaDocumento
        };
        updatedFormTipoDoc.value = "";
        this.setState({highestPrice: 0,piceaData: null, modalitaPagamento: updatedForm, clienteSelezionato: null, documentoInserito: false, numeroDocumento: updatedFormDoc, ricercaAnagrafica: updatedFormCliente, tipologiaDocumento: updatedFormTipoDoc, piceaSupervalutazione: null, piceaImei: null, piceaPriceChange: 0, piceaImeiDescription: null, couponTotalPrice: 0, piceaImeiInvalid: false, isNecessariaRicevuta: false, isRicevutaAcquisita: false,  marcaManuale: null, modelloManuale: null, memoriaManuale: null, imeiManuale: null});
        console.log("Annullamento del telefono");
    };

    selezionaConsole = () => {

        this.getDomande();

        let postData = {
            model_name: this.state.modelloManuale.replace(/\[.+?\]/, "").replace(" -", ""),
            brand: this.state.marcaManuale,
            memory: '32 GB'
        };
        let that = this;
        instance.post('/getDevicePrice', postData).then(function (resp) {
            if (resp.data.length > 0) {
                let price = resp.data[0].working_price;

                let serial = that.createRandomString();
                let deviceManualeInfo = {
                    "profileName": "SmartPhoneCash_STD_ITA",
                    "memory": that.state.memoriaManuale === 'Unique' ? "16 GB" : that.state.memoriaManuale,
                    "color": "",
                    "pending": {},
                    "loginCode": serial,
                    "imei2": "N/A",
                    "createdAt": "2025-02-14T08:13:57.000Z",
                    "blacklistStatus": {
                        "blacklistStatus": "Not reported lost or stolen",
                    },
                    "working": {},
                    "warranty": null,
                    "carrierLockRawResponse": "N/A",
                    "model": null,
                    "id": "xxx",
                    "make": that.state.marcaManuale,
                    "modelNo": that.state.modelloManuale,
                    "modelName": that.state.modelloManuale,
                    "serial": "xxx",
                    "imei": "N/A",
                    "passed": [],
                    "failed": [],
                };

                that.setState({isConsoleSelezionata: true, deviceInfo: deviceManualeInfo, deviceMaxPrice: price, deviceRealPrice: price});
            }
        })

    };

    createRandomString = () => {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        for (let i = 0; i < 9; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    };

    setInfoConsole = () => {

        let updateDeviceInfo = {
            ...this.state.deviceInfo
        };

        updateDeviceInfo.imei = this.state.serialeConsole.value;

        this.setState({deviceInfo: updateDeviceInfo, loading: true, isAccountEliminato: false, deviceMaxPrice: 0, isValutazioneEsteticaDefinita: false, isValutazioneEstetica: false, gradoValutazioneEstetica: 'A'});
        this.annullaImei();
        this.annullaNumeroDoc();
        this.annullaModalitaPagamento();
        this.setState({risposteInserite: true, loading :false})

        let postDataCampagne = {
            id_model_name: 0,
            id_negozio: localStorage.getItem("idNegozio") == 0 ? null : localStorage.getItem("idNegozio")
        };
        instance.post('/getCampagne', postDataCampagne).then(resp => {
            console.log(resp.data);
            for (let i in resp.data) {
                resp.data[i].validita = new Date(resp.data[i].data_inizio).toLocaleDateString() + " - " + new Date(resp.data[i].data_fine).toLocaleDateString();
                let operations = [];
                let seleziona = (<AddCircleIcon color="#768828" style={{width: '27px', cursor: 'pointer', padding: '2px', color: '#235884', fontSize: 'xx-large',  marginRight: '5px'}} onClick={() => this.selezionaSupervalutazione(resp.data[i])}>add_circle</AddCircleIcon> )
                operations.push(seleziona);
                resp.data[i].azioni = operations;
            }
            this.setState({campagne: resp.data})
        });
    };

    copyToCliborard = (link) => {
        navigator.clipboard.writeText(link);
        this.setState({confirmCopy: true})
    };

    handleMenu = (event) => {
        this.setState({anchorEl: event.currentTarget})
    };

    handleCloseMenu = () => {
        this.setState({anchorEl: null})
    };

    handleChangeOptions = (e, id) => {
        let oldDomande = [
            ...this.state.domande
        ];
        let index = oldDomande[0].id_domanda;
        let filteredRisposte = oldDomande[id - index].risposte.filter(function (resp) {
            return resp.id_risposta == e.target.value
        });
        let color = filteredRisposte[0].id_color;
        oldDomande[id - index].rispostaSelezionata = e.target.value;
        oldDomande[id - index].bgColor = color;
        console.log(oldDomande);
        let realPriceCalcolato = this.state.deviceMaxPrice;
        oldDomande.forEach(function (x) {
            if (x.rispostaSelezionata != null) {
                let filteredRisposte = x.risposte.filter(function (resp) {
                    return resp.id_risposta == x.rispostaSelezionata
                });
                if (filteredRisposte.length > 0)
                    realPriceCalcolato = filteredRisposte[0].svalutazione === 0.00 ? 1 : (realPriceCalcolato * filteredRisposte[0].svalutazione).toFixed(2)
            }
        });
        this.setState({domande: oldDomande, deviceRealPrice: ( (filteredRisposte[0].svalutazione == 0.00 || realPriceCalcolato < 1) ? 1 : realPriceCalcolato) })

    };

    render() {

        let authRedirect = null;
        console.log('[Buy-Device] isAuth? ' + this.props.isAuth);

        const StyledCardActionArea = styled(CardActionArea)(({theme}) =>
            `.MuiCardActionArea-focusHighlight {
                background: transparent;
                cursor: pointer;
            }`
        );

        const closeImeiAlertHandler = () => {
            this.annullaImei();
            this.annullaTelefono();
        };

        const ricevutaPresenteHandler = () => {
            this.ricevutaPresente()
        };
        const ricevutaAssenteHandler = () => {
            this.annullaInserimentoDevice();
        };

        const saltaSupervalutazione = () => {
            const updatedForm = {
                ...this.state.tipologiaSupervalutazione
            };
            updatedForm.value = 2;
            this.setState({ tipologiaSupervalutazione: updatedForm, modelNameCampagna: null });
        };

        let spinnerPicea = null;
        if (this.state.loadingPicea) {
            spinnerPicea = <Spinner/>
        }
        let spinner = null;
        if (this.state.loading) {
            spinner = <Spinner/>
        }

        let stickyHeader = null;

        if (this.state.deviceInfo != null) {
            stickyHeader = (
                <div className={classes.Sticky} id="myHeader">
                    <h2>{"DEVICE TRADE-IN: " + this.state.marcaManuale + " " + this.state.modelloManuale.replace(/\[.+?\]/, "").replace(" -", "") + " - VALORE: " + parseFloat(this.state.deviceRealPrice).toFixed(2) + " €"}</h2>
                </div>
            )
        }

        let ricevutaNecessaria = null;
        if (this.state.isNecessariaRicevuta) {
            ricevutaNecessaria =  (
                <Dialog
                    open={this.state.isNecessariaRicevuta}
                >
                    <DialogTitle style={{display:'flex',justifyContent:'center', alignItems:'center'}}>
                        <Error style={{color:'red'}}/>
                        ATTENZIONE
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Il dispositivo che si sta acquistando ha una valutazione massima <b>superiore ai 400 €</b><br/>
                            Confermi di essere in possesso della relativa ricevuta d'acquisto?<br/><br/>
                            In caso di assenza della prova d'acquisto il processo verrà interrotto<br/>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button clicked={ricevutaPresenteHandler}>
                            SI, è presente la ricevuta d'acquisto
                        </Button>
                        <Button clicked={ricevutaAssenteHandler}>
                            NO, la ricevuta è assente
                        </Button>
                    </DialogActions>
                </Dialog>)
        }

        let piceaSupervalutazione = null;
        if (this.state.piceaSupervalutazione > 0) {
            piceaSupervalutazione = (
                <div>
                    <p>{this.state.piceaImeiDescription } </p>
                </div>
            )
        }

        let modalitaPagamento = null;
        if ((this.state.risposteInserite && this.state.deviceInfo != null) ) {
            modalitaPagamento = (
                <div>
                    <p>Seleziona la modalità di pagamento</p>
                    <TextField
                        id="modalitaPagamento"
                        select
                        fullWidth
                        variant="outlined"
                        elementType="select"
                        color="success"
                        value={this.state.modalitaPagamento.value}
                        label="Modalità pagamento"
                        onChange={(e) => this.inputonChangeHandler(e, "modalitaPagamento")}
                    >
                        {this.state.modalitaPagamento.options.map((option) => (
                            <MenuItem key={option.key} value={option.key}>
                                {option.displayValue}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
            )
        }

        if (this.state.modalitaPagamento.value > 0) {
            modalitaPagamento = (
                <div className={classes.PassedTest}>
                    <p className={classes.Paragrafo}>Modalità pagamento scelta: {this.state.modalitaPagamento.options[this.state.modalitaPagamento.value].displayValue}</p>
                    <br/><Button clicked={() => this.annullaModalitaPagamento()}>ANNULLA</Button>
                </div>
            )
        }

        let formAnagrafica = null;
        if (this.state.modalitaPagamento.value > 0) {
            formAnagrafica = (
                <div>
                    <TextField
                        id="ricercaAnagrafica"
                        elementType="input"
                        variant="outlined"
                        value={this.state.ricercaAnagrafica.value}
                        label="Ricerca anagrafica"
                        style={{margin: 10}}
                        fullWidth
                        color="success"
                        helperText={this.state.ricercaAnagrafica.validationError}
                        error={!this.state.ricercaAnagrafica.valid && this.state.ricercaAnagrafica.touched}
                        onChange={(e) => this.inputonChangeHandler(e, "ricercaAnagrafica")}
                    />

                    <Button clicked={(e) => this.openModalRicercaCliente(this.state.ricercaAnagrafica.value)} disabled={!this.state.ricercaAnagrafica.valid || this.state.ricercaAnagrafica === ""}>Ricerca</Button>
                    <h5>oppure</h5>
                    <Button clicked={this.openModalCreazioneAnagrafica}>Inserisci Anagrafica</Button>
                </div>
            )
        }

        let modal = null;
        if (this.state.isRicercaAnagrafica) {
            modal = (
                <Modal show={this.state.isRicercaAnagrafica} modalClosed={this.ricercaCancelHandler} title={"Clienti Trovati"}>
                    {(this.state.loading ? <Spinner/> :
                            <Auxiliary>
                                <TableContainer>
                                    <Table stickyHeader size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Nome / Rag. Soc.</TableCell>
                                                <TableCell>C.F. / P. Iva</TableCell>
                                                <TableCell>&nbsp;</TableCell>
                                                <TableCell>&nbsp;</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                (this.state.listaAnagrafiche)
                                                    .slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                                    .map(cliente => (
                                                        <TableRow key={cliente.id_cliente}>
                                                            <TableCell component="th" scope="row">{cliente.cognome === "N.D." ? cliente.ragione_sociale : cliente.cognome + " " + cliente.nome}</TableCell>
                                                            <TableCell>{cliente.codice_fiscale === "N.D." ? cliente.partita_iva : cliente.codice_fiscale}</TableCell>
                                                            <TableCell><Button clicked={() => this.modificaAnagrafica(cliente)}>Modifica</Button></TableCell>
                                                            <TableCell><Button clicked={() => this.selezionaAnagrafica(cliente)}>Scegli</Button></TableCell>
                                                        </TableRow>
                                                    ))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[3, 5, 10]}
                                    component="div"
                                    count={this.state.listaAnagrafiche.length - 1}
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </Auxiliary>
                    )}

                </Modal>
            )
        }

        if (this.state.isCreazioneAnagrafica) {
            const formElementArray = [];
            for (let key in this.state.nuovaAnagrafica) {
                formElementArray.push({
                    id: key,
                    config: this.state.nuovaAnagrafica[key]
                })
            }

            if (this.state.nazioneEsteraChecked) {
                delete formElementArray[8];
                delete formElementArray[9];
            }

            let inputFields = formElementArray.map(el => (
                <TextField
                    name={el.id}
                    key={el.id}
                    label={el.config.elementConfig.placeholder}
                    variant="outlined"
                    value={el.config.value}
                    fullWidth
                    type={el.id == "password" ? "password" : "input" }
                    style={{width: '50%', align: 'center', margin: 10 }}
                    error={!el.config.valid && el.config.touched}
                    helperText={el.config.validationError}
                    touched={el.config.touched}
                    onChange={(e, id) => this.handleChangeAnagrafica(e, el.id)}
                />
            ));

            let sceltaNazioneField = (
                <div>
                    <FormControlLabel
                        control={<Checkbox checked={this.state.nazioneEsteraChecked} onChange={this.handleChangeCheckBox} />}
                        label="Stato Estero?"
                    />
                    <br/>
                    {this.state.nazioneEsteraChecked ? (
                        <TextField
                            id="modalitaPagamento"
                            select
                            fullWidth
                            variant="outlined"
                            elementType="select"
                            value={this.state.nazione.value}
                            label="Nazione"
                            style={{width: '50%', align: 'center', margin: 10 }}
                            // options={this.state.modalitaPagamento.options}
                            onChange={(e) => this.inputonChangeHandler(e, "nazione")}
                        >
                            {this.state.nazione.options.map((option) => (
                                <MenuItem key={option.sigla_nazione} value={option.sigla_nazione}>
                                    {option.paese}
                                </MenuItem>
                            ))}
                        </TextField>
                    ) : null}
                </div>
            );

            modal = (
                <Modal show={this.state.isCreazioneAnagrafica} modalClosed={this.ricercaCancelHandler} title={"Creazione Anagrafica"} customStyle={"Creazione Anagrafica"}>
                    <div style={{columns: 2}}>
                        {sceltaNazioneField}
                        {inputFields}
                    </div>
                    <Button clicked={this.creaAnagrafica} disabled={!this.state.formAnagraficaIsValid}>Crea Anagrafica</Button>
                </Modal>
            )
        }

        if (this.state.isModificaAnagrafica) {
            const formElementArray = [];
            for (let key in this.state.nuovaAnagrafica) {
                formElementArray.push({
                    id: key,
                    config: this.state.nuovaAnagrafica[key]
                })
            }
            let inputFields = formElementArray.map(el => (
                <TextField
                    name={el.id}
                    key={el.id}
                    color="success"
                    label={el.config.elementConfig.placeholder}
                    variant="outlined"
                    value={this.state.clienteDaModificare[el.id]}
                    type={el.id === "password" ? "password" : "input" }
                    style={{width: '50%', align: 'center', margin: 10 }}
                    error={!el.config.valid && el.config.touched}
                    helperText={el.config.validationError}
                    touched={el.config.touched}
                    onChange={(e) => this.handleChangeModifica(e)}
                />
            ));


            modal = (
                <Modal show={this.state.isModificaAnagrafica} modalClosed={this.ricercaCancelHandler} title={"Modifica Anagrafica"} customStyle={"Creazione Anagrafica"}>
                    <div style={{columns: 2}}>
                        {inputFields}
                    </div>
                    <Button clicked={this.creaAnagrafica}>Modifica</Button>
                </Modal>
            )
        }

        let infoCliente = null;
        if (this.state.clienteSelezionato !== null) {
            formAnagrafica = null;
            infoCliente = (
                <div className={classes.PassedTest}>
                    <p className={classes.Paragrafo}>{this.state.clienteSelezionato.cognome + " " + this.state.clienteSelezionato.nome}</p>
                    <Divider />
                    <p className={classes.Paragrafo}>{this.state.clienteSelezionato.codice_fiscale}</p>
                    <Divider />
                    <p className={classes.Paragrafo}>{this.state.clienteSelezionato.indirizzo + " " + this.state.clienteSelezionato.numero_civico + ", " + this.state.clienteSelezionato.citta}</p>
                    <br/><Button clicked={() => this.annullaCliente()}>ANNULLA</Button>
                </div>
            );
        }

        let tipologiaDocumento = null;
        if (this.state.clienteSelezionato !== null) {
            tipologiaDocumento = (
                <div>
                    <p>Seleziona la tipologia di documento</p>
                    <TextField
                        id="tipologiaDocumento"
                        elementType="select"
                        select
                        fullWidth
                        variant="outlined"
                        color="success"
                        value={this.state.tipologiaDocumento.value}
                        label="Tipologia Documento Identificazione"
                        options={this.state.tipologiaDocumento.options}
                        onChange={(e) => this.inputonChangeHandler(e, "tipologiaDocumento")}
                    >
                        {this.state.tipologiaDocumento.options.map((option) => (
                            <MenuItem key={option.key} value={option.key}>
                                {option.displayValue}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
            )
        }

        if (this.state.tipologiaDocumento.value > 0) {
            tipologiaDocumento = (
                <div className={classes.PassedTest}>
                    <p className={classes.Paragrafo}>Documento identificazione: {this.state.tipologiaDocumento.options[this.state.tipologiaDocumento.value].displayValue}</p>
                    <br/><Button clicked={() => this.annullaDoc()}>ANNULLA</Button>
                </div>
            )
        }

        let numeroDocumento = null;
        if (this.state.tipologiaDocumento.value > 0) {
            numeroDocumento = (
                <div>
                    <p>Inserisci il numero del documento</p>
                    <TextField
                        id="numeroDocumento"
                        elementType="input"
                        fullWidth
                        value={this.state.numeroDocumento.value}
                        label="Numero Documento"
                        variant="outlined"
                        color="success"
                        style={{margin: 10}}
                        onChange={(e) => this.inputonChangeHandler(e, "numeroDocumento")}
                    />
                    <Button clicked={this.confermaDocumentoPhoneCheck} disabled={this.state.numeroDocumento.value.length < 7}>Conferma Documento</Button>
                </div>
            )
        }

        if (this.state.documentoInserito) {
            tipologiaDocumento = null;
            numeroDocumento = (
                <div className={classes.PassedTest}>
                    <p className={classes.Paragrafo}>Documento identificazione: {this.state.tipologiaDocumento.options[this.state.tipologiaDocumento.value].displayValue} {this.state.numeroDocumento.value.toLocaleUpperCase()}</p>
                    <br/><Button clicked={() => this.annullaNumeroDoc()}>ANNULLA</Button>
                </div>
            )
        }

        const newColumnsCampagne = [
            {accessorKey: 'id_campagna', header: 'Campagna', editable: false, size: 100},
            {accessorKey: 'sku', header: 'SKU', editable: false, size: 100},
            {accessorKey: 'model_name_campagna', header: 'Device supervalutazione', editable: false, size: 100},
            {accessorKey: 'supervalutazione', header: 'Valore', editable: false, size: 80, Cell: ({ cell }) => cell.getValue() + " €"},
            {accessorKey: 'validita', header: 'Validità', editable: false, size: 100},
            {accessorKey: 'azioni', header: 'Seleziona', editable: false}
        ];

        let supervalutazione = null;

        if (this.state.documentoInserito && this.state.tipologiaSupervalutazione.value === 0 && this.state.isAffiliatoAttivoSupervalutazione && this.state.modalitaPagamento.value === 1 && this.state.campagne.length > 0) {
            supervalutazione = (
                <Auxiliary>
                    <Box style={{textAlign: '-webkit-center', display: 'inline-block', width: '100%'}}>
                        <Box className={classes.ResultBox}>
                            <h3 className={classes.FiltriTitle}>Campagne attive per il dispositivo </h3>
                            <MaterialReactTable
                                columns={newColumnsCampagne}
                                data={this.state.campagne}
                                enableColumnActions={false}
                                enableColumnFilters={false}
                                enablePagination={false}
                                enableSorting={false}
                                enableBottomToolbar={false}
                                enableTopToolbar={true}
                                initialState={{ columnPinning: { right: ['azioni'] }, density: 'compact'}}
                                muiTableBodyRowProps={{ hover: false }}
                            />
                        </Box>
                        <Button
                            color="primary"
                            clicked={() => saltaSupervalutazione()}
                            variant="contained"
                        >{'SALTA SUPERVALUTAZIONE'}
                        </Button>
                    </Box>
                </Auxiliary>
            )
        }

        let imeiFieldSupervalutazione = (
            <TextField
                id="imeiSupervalutazione"
                elementType="input"
                fullWidth
                value={this.state.imeiSupervalutazione.value}
                label="IMEI Prodotto Acquistato"
                variant="outlined"
                style={{margin: 10}}
                helperText={this.state.datiSupervalutazione.imei === 1 ? "Campo obbligatorio - Lughezza 15 caratteri" : ""}
                onChange={(e) => this.inputonChangeHandler(e, "imeiSupervalutazione")}
            />
        );

        let skuSupervalutazione = (
            <TextField
                id="skuSupervalutazione"
                elementType="input"
                fullWidth
                value={this.state.skuSupervalutazione.value}
                label="Model Nuber / SKU Prodotto Acquistato"
                variant="outlined"
                style={{margin: 10}}
                helperText={this.state.datiSupervalutazione.serial === 1 ? "Campo obbligatorio" : ""}
                onChange={(e) => this.inputonChangeHandler(e, "skuSupervalutazione")}
            />
        );

        let eanSupervalutazione = (
            <TextField
                id="eanSupervalutazione"
                elementType="input"
                fullWidth
                value={this.state.eanSupervalutazione.value}
                label="EAN Prodotto Acquistato"
                variant="outlined"
                style={{margin: 10}}
                helperText={this.state.datiSupervalutazione.ean === 1 ? "Campo obbligatorio" : ""}
                onChange={(e) => this.inputonChangeHandler(e, "eanSupervalutazione")}
            />
        );

        let imeiSupervalutazione = null;
        if (this.state.tipologiaSupervalutazione.value === 1 && !this.state.supervalutazioneInserita) {

            let buttonDisabled =
                (this.state.imeiSupervalutazione.value.length !== 15 && this.state.datiSupervalutazione.imei === 1) ||
                (this.state.skuSupervalutazione.value.length < 6 && this.state.datiSupervalutazione.serial === 1) ||
                (this.state.eanSupervalutazione.value.length < 10 && this.state.datiSupervalutazione.ean === 1);

            if (this.state.datiSupervalutazione.imei === 1 && this.state.imeiSupervalutazione.value.length === 15) {
                buttonDisabled = buttonDisabled || !(/^\d+$/.test(this.state.imeiSupervalutazione.value))
            }

            imeiSupervalutazione = (
                <Auxiliary>
                    <div>
                        <div className={classes.PassedTest}>
                            <p className={classes.Paragrafo}>Campagna valida per : {this.state.modelNameCampagna}  </p>
                            <p className={classes.Paragrafo}>Valore supervalutazione: {this.state.valoreSupervalutazione} €</p>
                            <br/><Button clicked={() => this.annullaImei()}>ANNULLA INSERIMENTO SUPERVALUTAZIONE</Button>
                        </div>
                        <br />
                        {this.state.datiSupervalutazione.imei === 1 ? imeiFieldSupervalutazione : null}
                        {this.state.datiSupervalutazione.serial === 1 ? skuSupervalutazione : null}
                        {this.state.datiSupervalutazione.ean === 1 ? eanSupervalutazione : null}
                        <br />
                        <Button clicked={this.confermaSupervalutazione} disabled={buttonDisabled}>Conferma</Button>
                    </div>
                </Auxiliary>
            )
        }

        let imeiNonValido = null;
        if (this.state.piceaImeiInvalid) {
            imeiNonValido = (
                <Dialog
                    open={this.state.piceaImeiInvalid}
                >
                    <DialogTitle style={{display:'flex',justifyContent:'center', alignItems:'center'}}>
                        <Error style={{color:'red'}}/>
                        ATTENZIONE
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            L'IMEI del telefono acquistato non è valido per la promozione<br/>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button clicked={closeImeiAlertHandler} autoFocus>
                            CHIUDI
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        }

        let imeiInserito = null;
        if (this.state.supervalutazioneInserita) {
            imeiInserito =
                <Auxiliary>
                    {imeiNonValido}
                    <div className={classes.PassedTest}>
                        <p className={classes.Paragrafo}>Campagna valida per : {this.state.modelNameCampagna} </p>
                        <br/><Button clicked={() => this.annullaImei()}>ANNULLA INSERIMENTO IMEI</Button>
                    </div>
                </Auxiliary>
        }

        let qrCode = null;
        let buttonStampaRicevuta = null;
        let riassuntoPermuta = null;

        let showQrCode = (this.state.modalitaPagamento.value === 2 && this.state.documentoInserito) || (this.state.supervalutazioneInserita && this.state.documentoInserito) || ((this.state.tipologiaSupervalutazione.value === 2 && this.state.documentoInserito)) || (!this.state.isAffiliatoAttivoSupervalutazione && this.state.documentoInserito) || (this.state.documentoInserito && this.state.campagne.length === 0);
        if (showQrCode && !this.state.piceaImeiInvalid) {

            riassuntoPermuta = (
                <div className={classes.PassedTest}>
                    <p className={classes.Paragrafo}>VALORE FINALE DISPOSITIVO: {parseFloat(this.state.deviceRealPrice).toFixed(2)} € </p>
                </div>
            );

            qrCode = (
                <div style={{marginTop: '1%'}} className={classes.PassedTest}>
                    <QRCode
                        value={ednpointWeb + "/takePhoto?cf=" + this.state.clienteSelezionato.codice_fiscale + "&device=" + this.state.piceaData.serial_number + "&negozio=" + localStorage.getItem("idNegozio") + "&idc=" + this.state.clienteSelezionato.id_cliente + "&nt=" + this.state.numTimes}/>
                    <p>Inquadra il QR Code dal cellulare per scattare le foto al documento</p>
                    <Button clicked={() => this.copyToCliborard(ednpointWeb + "/takePhoto?cf=" + this.state.clienteSelezionato.codice_fiscale + "&device=" + this.state.piceaData.serial_number + "&negozio=" + localStorage.getItem("idNegozio") + "&idc=" + this.state.clienteSelezionato.id_cliente + "&nt=" + this.state.numTimes)}>Copia Link</Button>
                </div>
            );

            buttonStampaRicevuta = (
                <Box className={classes.ResultBox} style={{witdh: '50%'}}>
                    <p style={{fontSize: 'larger'}}><strong>Dopo aver completato le firme e caricato i documenti vai su <span onClick={() => this.props.history.push('/magazzino')} style={{cursor: 'pointer', fontSize: 'xx-large', color: '#768828'}}>Magazzino</span> per stampare la ricevuta completa</strong><br />
                    </p>
                </Box>
            )
        }
        let confermaDocumento = null;
        if (this.state.isStampaDocumento && this.state.isDocumentoFirmato) {
            const codDocumento = this.state.piceaData.serial_number + "-" + this.state.numTimes;
            window.open(ednpointWeb + "/stampaRicevuta?cod=" + codDocumento);

            confermaDocumento = (
                <Snackbar open={true} closed={this.handleClose} severity="success">Ricevuta firmata correttamente!</Snackbar>
            )
        } else if (this.state.isStampaDocumento && !this.state.isDocumentoFirmato) {
            confermaDocumento = (
                <Snackbar open={true} closed={this.handleClose}  severity="error">La ricevuta digitale non è ancora stata completata</Snackbar>
            )
        }

        let confirmCopy = (
            <Snackbar open={this.state.confirmCopy} autoHideDuration={2000} closed={this.handleClose} severity="success">Link copiato negli appunti!</Snackbar>
        );



        let deviceInfoForm = null;
        let deviceName = null;

        if (this.state.deviceInfoError != null) {
            deviceInfoForm = (
                <Auxiliary>
                    <Box style={{textAlign: 'center'}}>
                        <Box className={classes.ResultBox}>
                            <h3 className={classes.ErrorTitle}>
                                {deviceName}
                            </h3>
                        </Box>
                    </Box>
                </Auxiliary>
            )
        }




        let boxTestConsole = null;


        let domandeConsole = this.state.domande.map((item) => (
                <Card elevation={0} className={classes.Side} variant="outlined" style={{backgroundColor: (this.state.lettoreCd ? item.bgColor : item.id_domanda == 2 ? '#CCC' : item.bgColor)}}>
                    <CardActionArea >
                        <CardContent>
                            <FormControl>
                                <FormLabel className={classes.UndexText}><strong>{item.domanda}</strong></FormLabel>
                                <Divider />
                                <RadioGroup
                                    value={item.rispostaSelezionata}
                                    onChange={(e) => this.handleChangeOptions(e, item.id_domanda)}

                                >
                                    {item.risposte.map((itemRisposta) => (
                                        <FormControlLabel className={classes.RadioLabel} value={itemRisposta.id_risposta} control={<Radio />} label={itemRisposta.risposta} disabled={!this.state.lettoreCd && item.id_domanda == 2} />
                                    ) )}
                                </RadioGroup>
                            </FormControl>
                        </CardContent>
                    </CardActionArea>
                </Card>
            )

        );

        let boxSeriale = (<Auxiliary>
            <p style={{fontSize: 'larger', display: 'inline-block'}}>
                Seriale dello smartwatch:
            </p>
            <TextField
                id="serialeConsole"
                elementType="input"
                variant="outlined"
                value={this.state.serialeConsole.value}
                label="Seriale Console"
                style={{margin: 10, display: 'inline-block'}}
                disabled
                helperText={this.state.serialeConsole.validationError}
                error={!this.state.serialeConsole.valid && this.state.serialeConsole.touched}
            />
            < br/>
            <Divider />
        </Auxiliary>);

        let boxRisposte = this.state.domande.map((item) => (

                <Card elevation={0} className={classes.Side} variant="outlined" style={{backgroundColor: (this.state.lettoreCd ? item.bgColor : item.id_domanda == 2 ? '#CCC' : item.bgColor)}}>
                    <CardActionArea >
                        <CardContent>
                            <FormControl>
                                <FormLabel className={classes.UndexText}><strong>{item.domanda}</strong></FormLabel>
                                <Divider />
                                <RadioGroup
                                    value={item.rispostaSelezionata}
                                    disabled
                                >
                                    {item.risposte.map((itemRisposta) => (
                                        <FormControlLabel className={classes.RadioLabel} value={itemRisposta.id_risposta} control={<Radio />} label={itemRisposta.risposta} disabled={!this.state.lettoreCd && item.id_domanda == 2} />
                                    ) )}
                                </RadioGroup>
                            </FormControl>
                        </CardContent>
                    </CardActionArea>
                </Card>
            )

        );

        let risposteSelezionate = true;
        for (let i = 0; i < this.state.domande.length && risposteSelezionate;  ++i) {
            if (!this.state.lettoreCd && i === 1) risposteSelezionate = true;
            else risposteSelezionate = this.state.domande[i].rispostaSelezionata != null;
        }
        risposteSelezionate = risposteSelezionate && this.state.serialeConsole.value !== '';
        if (this.state.isConsoleSelezionata) {
            boxTestConsole = (<Box className={classes.ResultBox}>
                <Auxiliary>
                    <p style={{fontSize: 'larger'}}><strong>Valutazione dello smartwatch:</strong><br />
                        Compilare tutti i campi e cliccare su "Inserisci informazioni smartwatch" per proseguire
                    </p>
                    <Divider />
                    <p style={{fontSize: 'larger', display: 'inline-block'}}>
                        Inserire il seriale dello smartwatch:
                    </p>
                    <TextField
                        id="serialeConsole"
                        elementType="input"
                        variant="outlined"
                        value={this.state.serialeConsole.value}
                        label="Seriale Smartwatch"
                        style={{margin: 10, display: 'inline-block'}}
                        color="success"
                        helperText={this.state.serialeConsole.validationError}
                        error={!this.state.serialeConsole.valid && this.state.serialeConsole.touched}
                        onChange={(e) => this.inputonChangeHandler(e, "serialeConsole")}
                    />
                    < br/>
                    <Divider />
                    <div>
                        {domandeConsole}
                    </div>
                    <div>
                        <Button clicked={this.setInfoConsole} disabled={!risposteSelezionate}>INSERISCI INFORMAZIONI SMARTWATCH</Button>
                    </div>
                </Auxiliary>

            </Box>)
        }

        let boxInfoCliente = null;
        if (this.state.risposteInserite ) {
            boxInfoCliente = (
                <Box className={classes.ResultBox}>
                    {boxSeriale}
                    {boxRisposte}
                    {modalitaPagamento}
                    {confermaDocumento}
                    {confirmCopy}
                    {infoCliente}
                    {tipologiaDocumento}
                    {numeroDocumento}
                    {formAnagrafica}
                </Box>)
        }
        if (this.state.risposteInserite)
            boxTestConsole = (
                <Auxiliary>
                    {deviceInfoForm}
                    {modal}
                    {supervalutazione}
                    {imeiSupervalutazione}
                    {imeiInserito}
                    {riassuntoPermuta}
                    {qrCode}
                </Auxiliary>);

        let formMemoria = (
            <Autocomplete
                id="memoria"
                sx={{backgroundColor: '#f4f4f4', width: '400px', margin: 5, borderRadius: '4px', display: 'inline-block',
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#768828",
                        }
                }}
                // value={this.state.idMemoriaSelezionato}
                options={this.state.memoria}
                // getOptionLabel={option => option.label}
                autoHighlight
                size="small"
                variant="outlined"
                onChange={this.onMemoryChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.54)' },
                        }}
                        label="Seleziona Capacità Dispositivo"
                        slotProps={{
                            htmlInput: {
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            },
                        }}
                    />
                )}
            />
        );

        let formBrand = (
            <Autocomplete
                id="brand"
                sx={{backgroundColor: '#f4f4f4', width: '400px', margin: 5, borderRadius: '4px',  display: 'inline-block',
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#768828",
                        }
                }}
                options={this.state.brands}
                autoHighlight
                size="small"
                variant="outlined"
                // value={this.state.idBrandSelezionato ? this.state.idBrandSelezionato.key : null}
                // isOptionEqualToValue={(option, value) => option.label === value}
                // getOptionLabel={(option) =>  option.label ? option.label : ""}
                onChange={this.onBrandsChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.54)' },
                        }}
                        label="Seleziona Brand Dispositivo"
                        slotProps={{
                            htmlInput: {
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            },
                        }}
                    />
                )}
            />
        );

        let formModello = (
            <Autocomplete
                id="modello"
                key={`modello-${this.state.idBrandSelezionato}`}
                sx={{backgroundColor: '#f4f4f4', width: '400px', margin: 5, borderRadius: '4px', display: 'inline-block',
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                        {
                            borderColor: "#768828",
                        }
                }}
                options={this.state.modelli}
                autoHighlight
                size="small"
                variant="outlined"
                // value={this.state.idModelSelezionato}
                onChange={this.onModelsChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        InputLabelProps={{
                            style: { color: 'rgba(0, 0, 0, 0.54)' },
                        }}
                        label="Seleziona Modello Dispositivo"
                        slotProps={{
                            htmlInput: {
                                ...params.inputProps,
                                autoComplete: 'new-password', // disable autocomplete and autofill
                            },
                        }}
                    />
                )}
            />
        );

        let boxSceltaConsole = (
            <Box style={{textAlign: 'center'}}>
                <Box className={classes.ResultBox}>
                    <p style={{fontSize: 'larger'}}><strong>Selezionare il modello di smartwatch:</strong><br />
                    </p>
                    <div>
                        {formBrand}
                        {formModello}
                        {/*{formMemoria}*/}
                    </div>
                </Box>
                <Button clicked={this.selezionaConsole}>SELEZIONA SMARTWATCH</Button>
                {spinner}
                {deviceInfoForm}
                {modal}
                {boxInfoCliente}
            </Box>
        );


        return (
            <Auxiliary className={classes.BuySmartwatch}>
                {stickyHeader}
                <div className={classes.BuySmartwatch}>
                    {authRedirect}
                    <h1 className={classes.Title}> ACQUISTO SMARTWATCH </h1>
                </div>
                <form onSubmit={e => e.preventDefault()}>
                    <div className={classes.BuySmartwatch}>
                        {boxSceltaConsole}
                        {boxTestConsole}
                        {piceaSupervalutazione}
                        {spinnerPicea}
                        {ricevutaNecessaria}
                    </div>
                    <div className={classes.BuySmartwatch}>
                        {buttonStampaRicevuta}
                    </div>
                </form>
            </Auxiliary>
        );
    }
}


const mapDispatchToProps = dispatch => {
    return {
        onAuthCheckState: () => dispatch(actions.authCheckState()),
        onCheckLinkPicea: (event) => dispatch(actions.inserimentoPicea(event)),
        onResetLinkPicea: () => dispatch(actions.resetLinkPicea())
    }
};


const mapStateToProps = state => {
    return {
        isAuth: state.auth.token !== null,
        // authRedirectPath: "/buy-device",
        negozio: state.auth.negozio
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(BuySmartwatch);
